module.exports = __webpack_public_path__ + "static/media/Bicocca - white_LT Gold.d9d6ae6a.jpg";